import { render, staticRenderFns } from "./silde.vue?vue&type=template&id=48e47a80&scoped=true&"
import script from "./silde.vue?vue&type=script&lang=js&"
export * from "./silde.vue?vue&type=script&lang=js&"
import style0 from "./silde.vue?vue&type=style&index=0&id=48e47a80&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e47a80",
  null
  
)

export default component.exports